import React from 'react'
import { responsive, Container, TextWrapper, Text, Button, Icons, ShadowWrapper } from "./style"

import FeedbackCard from "../FeedbackCard"
import { cardData } from "../../mock/cardData"
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";


const FeedbackCarousel = () => {
  return (
    <Container>
      <TextWrapper>
        <Text>Our customers say</Text>
        <Button>Button  <Icons.RightArrow /> </Button>
      </TextWrapper>
      <Carousel
        additionalTransfrom={0}
        autoPlay
        autoPlaySpeed={3500}
        centerMode={false}
        className=""
        containerClass="container-with-dots"
        dotListClass=""
        draggable
        focusOnSelect={false}
        infinite
        itemClass=""
        keyBoardControl
        minimumTouchDrag={80}
        renderButtonGroupOutside={false}
        renderDotsOutside={false}
        responsive={responsive}>
        {cardData.map((value) => {
          return (
            <FeedbackCard key={value.id} value={value} />
          )
        })}
      </Carousel>
      <ShadowWrapper />
      <ShadowWrapper position />
    </Container>

  )
}
export default FeedbackCarousel
